import React from 'react';

const WarningIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.76758 9.10938C5.91341 9.10938 6.04102 9.05469 6.15039 8.94531C6.25977 8.83594 6.31445 8.70833 6.31445 8.5625C6.31445 8.41667 6.25977 8.28906 6.15039 8.17969C6.04102 8.07031 5.91341 8.01562 5.76758 8.01562C5.62174 8.01562 5.49414 8.07031 5.38477 8.17969C5.27539 8.28906 5.2207 8.41667 5.2207 8.5625C5.2207 8.70833 5.27539 8.83594 5.38477 8.94531C5.49414 9.05469 5.62174 9.10938 5.76758 9.10938ZM5.29883 6.85938H6.23633V2.75H5.29883V6.85938ZM3.42383 11.625L0.142578 8.34375V3.65625L3.42383 0.375H8.11133L11.3926 3.65625V8.34375L8.11133 11.625H3.42383ZM3.81445 10.6875H7.7207L10.4551 7.95312V4.04688L7.7207 1.3125H3.81445L1.08008 4.04688V7.95312L3.81445 10.6875Z"
      fill="white"
    />
  </svg>
);

export default WarningIcon;
